import React from "react";
import { useTranslation } from "react-i18next";

import Flex from "../../../components/Flex/Flex";
import CoverImage from "../../ui/components/CoverImage/CoverImage";
import { timestampColumn } from "../../ui/utils/columns";

export default function useSeriesTableColumns() {
	const { t } = useTranslation();

	return [
		{
			id: "serie.name",
			Header: t("name", "Name"),
			Cell: ({ value, row }) => {
				const work = row.works[0];

				return (
					<Flex justifyContent="flex-start">
						<div style={{ marginRight: "1em", height: 40, width: 40 }}>
							<CoverImage thumb rounded data={work} size={40} style={{ margin: "0 auto" }} />
						</div>

						<div>{value}</div>
					</Flex>
				);
			},
		},
		{
			id: "works",
			Header: t("works", "Works"),
			accessor: ({ works }) => works.length,
		},
		{
			id: "author",
			Header: t("author", "Author"),
			accessor: ({ works }) => {
				const allAuthors = works.flatMap((work) => work.authors || []);

				return [...new Set(allAuthors)].join(", ");
			},
		},
		timestampColumn({
			id: "created",
			Header: t("created", "Created"),
			time: false,
			accessor: ({ serie }) => serie.created?.toDate?.(),
		}),
	];
}
